(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-laser-animation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lf-engraver')){
  customElements.define('lf-engraver',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();this.head=this.querySelector('[data-head]');this.gantry=this.querySelector('[data-gantry]');this.reveal=this.querySelector('[data-reveal]');this.light=this.querySelector('[data-light]');this.status=this.querySelector('[data-status]');this.button=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.elapsed=0;this.visible=false;this.paused=false;
      this.button.addEventListener('click',()=>{this.paused=!this.paused;this.button.setAttribute('aria-pressed',String(this.paused));this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.pause;this.sync();},{signal:this.abort.signal});
      this.motion.addEventListener('change',()=>this.sync(),{signal:this.abort.signal});document.addEventListener('visibilitychange',()=>this.sync(),{signal:this.abort.signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.05});this.observer.observe(this);this.draw(12500);
    }
    sync(){cancelAnimationFrame(this.frame);this.last=0;this.button.hidden=this.motion.matches;if(this.motion.matches){this.draw(12500);return;}if(this.visible&&!this.paused&&!document.hidden)this.frame=requestAnimationFrame(t=>this.tick(t));}
    tick(t){if(this.last)this.elapsed+=t-this.last;this.last=t;this.draw(this.elapsed%15000);this.frame=requestAnimationFrame(n=>this.tick(n));}
    draw(t){
      let x=300,y=105,h=0,active=false;
      if(t>=700&&t<11700){const p=(t-700)/11000;const sweep=p*28;const row=Math.floor(sweep);const fraction=sweep-row;x=row%2===0?185+230*fraction:415-230*fraction;y=135+230*p;h=230*p;active=true;}
      else if(t>=11700){h=230;const park=Math.min((t-11700)/700,1);x=185+(300-185)*park;y=365+(105-365)*park;}
      this.head.setAttribute('transform',`translate(${x.toFixed(2)} ${y.toFixed(2)})`);this.gantry.setAttribute('transform',`translate(0 ${(y-42).toFixed(2)})`);this.reveal.setAttribute('height',h.toFixed(2));this.light.setAttribute('opacity',active?'1':'0');const text=t>=11700?this.dataset.finished:this.dataset.working;if(this.status.textContent!==text)this.status.textContent=text;
    }
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.abort?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
